import moment from 'moment';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { actions } from '../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBellSlash } from '@fortawesome/free-solid-svg-icons';
import { faBell as faBellOutline } from '@fortawesome/free-regular-svg-icons';
import { useCallback } from 'react';

const Mute = ({ id, name, muteUntil = 0, muteNote = null }) => {
    const dispatch = useDispatch();

    const onClick = useCallback(() => {
        let practiceMute = { muteUntil, muteNote };
        const payload = { id, name, practiceMute };
        dispatch(actions.practice.selectPracticeToMute(payload));
        dispatch(actions.toggle.toggleMutePracticeModal(true));
    }, [id, name, muteNote, muteUntil, dispatch]);

    const isMuted = muteUntil && moment.unix(muteUntil) > moment();

    return (
        <div>
            <FontAwesomeIcon
                className={classNames(`pop-hover`, {
                    'hover-child': !isMuted,
                })}
                icon={isMuted ? faBellSlash : faBellOutline}
                onClick={onClick}
            />
        </div>
    );
};

export default Mute;
